import styled from 'styled-components'

import breakpoints from '../../theme/breakpoints'
import ActionButton from '../ActionButton'

export const Footer = styled.footer`
  width: 100%;
  height: 90px;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  border-top: 1px solid black;
  display: flex;

  ${breakpoints.down('tablet')} {
    justify-content: center;
    flex-wrap: wrap;
  }
`

export const Link = styled(ActionButton)`
  &,
  button {
    ${({ theme }) => theme.textStyles.text};
    text-transform: none;
    color: ${({ theme }) => theme.colors.pureBlack} !important;
    font-size: 14px !important;
    padding: 0 !important;
    height: auto;
    display: contents;
  }

  & {
    background-color: transparent !important;
  }

  &:active {
    outline: none !important;
  }

  text-decoration: none;

  &:not(:first-child):before {
    content: '|';
    margin: 0 10px;
  }
`
